// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__jsJRC","content":"styles_content__1GxIT","docList":"styles_docList__kt-Ak","actions":"styles_actions__bBqNx","listItem":"styles_listItem__BtnXT"};